import router, { resetRouter } from "@/router";
import {getToken,setToken,removeToken} from '@/utils/auth'

const state = {
  token: getToken(),
}
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
    // location.reload()
  },
};

const actions = {
  setToken({ commit }, tokenStr){
    commit("SET_TOKEN", tokenStr);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
